import { ENGT_CHAT } from 'js/bot.model';

const ENGATI_LS_PREFIX = 'engt_';

export const LS = () => ({
	USER_LOCALE: `${ENGATI_LS_PREFIX}user_language-${ENGT_CHAT.get('config.bot_key')}userLanguage`,
	USER_PREFERENCE: `${ENGATI_LS_PREFIX}user_preference_${ENGT_CHAT.get('config.bot_key')}`,
	IP_ADDRESS: `${ENGATI_LS_PREFIX}${ENGT_CHAT.get('config.bot_key')}ipAddress`,
	NEW_SESSION: `${ENGATI_LS_PREFIX}${ENGT_CHAT.get('config.bot_key')}newSessionKey`,
	MESSAGE_MAP: `${ENGATI_LS_PREFIX}${ENGT_CHAT.get('config.bot_key')}messageMap`,
	LIVECHAT: `${ENGATI_LS_PREFIX}livechat-${ENGT_CHAT.get('config.bot_key')}-${ENGT_CHAT.get('status.sessionKey')}`,
	PREV_MESSAGES: `${ENGATI_LS_PREFIX}messages-${ENGT_CHAT.get('config.bot_key')}-${ENGT_CHAT.get(
		'status.sessionKey'
	)}`,
	IS_NOTIFED: `notified-${ENGT_CHAT.get('config.bot_key')}-${ENGT_CHAT.get('status.sessionKey')}`,
	FONT_SETTING: `${ENGATI_LS_PREFIX}${ENGT_CHAT.get('config.bot_key')}-font-setting`,
	GOT_UID: `${ENGATI_LS_PREFIX}gotUid-${ENGT_CHAT.get('config.bot_key')}`,
	TAB_MESSAGES: `${ENGATI_LS_PREFIX}tabbed_msg-${ENGT_CHAT.get('config.bot_key')}-${ENGT_CHAT.get(
		'status.sessionKey'
	)}`,
	TAB_COUNTER: `${ENGATI_LS_PREFIX}tab-counter-${ENGT_CHAT.get('config.bot_key')}-${ENGT_CHAT.get(
		'status.sessionKey'
	)}`,
	RUD_NODE: `${ENGATI_LS_PREFIX}currentRUDNode-${ENGT_CHAT.get('config.bot_key')}`,
	STOP_AUDIO_RECORDING: `${ENGATI_LS_PREFIX}_stop_audio_recording_${ENGT_CHAT.get('config.bot_key')}`,
});
